var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.36 16.528a.576.576 0 0 0 .09-.09l2.801-3.502a.576.576 0 0 0-.45-.936L13 12.001 13 5.576A.576.576 0 0 0 12.424 5h-.848a.576.576 0 0 0-.576.576v6.425L9.197 12a.576.576 0 0 0-.45.936l2.802 3.502a.576.576 0 0 0 .81.09z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 15.2v1.848c0 .636.516 1.152 1.152 1.152h10.896c.636 0 1.152-.516 1.152-1.152V15.2h2.2v3.072c0 .954-.774 1.728-1.728 1.728H4.928A1.728 1.728 0 0 1 3.2 18.272V15.2h2.2z",
    fill: "#FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-download.d5df80aa3f8604453b3041b3338d9109.svg";